<ng-container *ngIf="isDxsales">
    <app-collabo-portal-dxsales-updated-password [clientId]="clientId"></app-collabo-portal-dxsales-updated-password>
</ng-container>